import React, { useEffect, useState } from 'react';

const UserFormModal = ({ onChange }) => {
  const [nombre, setNombre] = useState('');
  const [mail, setMail] = useState('');

  const [errors, setErrors] = useState({
    nombre: '',
    mail: '',
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isFormValid = nombre.trim() !== '' && validateEmail(mail);

  useEffect(() => {
    if (onChange) {
      onChange({ nombre, mail, isValid: isFormValid });
    }
  }, [nombre, mail, isFormValid, onChange]);

  const handleBlur = (field) => {
    const newErrors = { ...errors };

    if (field === 'nombre' && nombre.trim() === '') {
      newErrors.nombre = 'El nombre es obligatorio.';
    } else {
      newErrors.nombre = '';
    }

    if (field === 'mail' && !validateEmail(mail)) {
      newErrors.mail = 'El correo electrónico no es válido.';
    } else {
      newErrors.mail = '';
    }

    setErrors(newErrors);
  };

  return (
    <form>
      <div className="mb-3">
        <label htmlFor="nombre" className="form-label">Nombre y Apellido</label>
        <input
          type="text"
          className={`form-control ${errors.nombre ? 'is-invalid' : ''}`}
          id="nombre"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          onBlur={() => handleBlur('nombre')}
          required
        />
        {errors.nombre && <div className="invalid-feedback">{errors.nombre}</div>}
      </div>
      <div className="mb-3">
        <label htmlFor="mail" className="form-label">Correo</label>
        <input
          type="email"
          className={`form-control ${errors.mail ? 'is-invalid' : ''}`}
          id="mail"
          value={mail}
          onChange={(e) => setMail(e.target.value)}
          onBlur={() => handleBlur('mail')}
          required
        />
        {errors.mail && <div className="invalid-feedback">{errors.mail}</div>}
      </div>
    </form>
  );
};

export default UserFormModal;
